module.exports = __webpack_public_path__ + "media/images/flags/TL-b852fc02a08502ef504f56c221a631d1.svg";